import axios from '@/config/axios.config';
import handleRequest from '@/helpers/handleRequest';

const ENDPOINTS = {
    getReceipt: (orderId) => `/bbpay/receipt/${orderId}`,
    abandonPreorder: (preorderId) => `/preorder/abandon/${preorderId}`,
};


export default {
    async getReceipt(orderId) {
        return await handleRequest(
            {},
            () => axios.get(ENDPOINTS.getReceipt(orderId), {
                responseType: 'blob',
                headers: {
                    'Accept': 'application/pdf'
                }
            })
        );
    },

    async abandonPreorder(preorderId) {
        const simulatedData = { Data: { OrderId: preorderId } };
        return await handleRequest(
            simulatedData,
            () => axios.post(ENDPOINTS.abandonPreorder(preorderId), {})
        );
    },
};
